export default [
  {
    path: '/activity-20260220-main',
    component: () => import('./Page.vue'),
    meta: { title: '财神赐福', id: 20 },
  },
  {
    path: '/activity-20260220-rule',
    component: () => import('./Rule.vue'),
    meta: { title: '财神赐福-规则', id: 20 },
  },
]
